import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
//import { FroalaEditorOptions } from 'src/app/data/constants/froala-editor-options';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { CompanyService } from 'src/app/services/company.service';
import { PetitionFeesInfo } from 'src/app/data/models/petitionFeesInfo.model';
import { Company } from 'src/app/data/models/company.model';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environment-configurations';
import { ConfirmationService } from 'primeng/api';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import { ReferenceLibrary } from '../../../data/models/referenceLibrary.model';
import { UploadDocumentService } from '../../../services/upload-document.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadImageDialogComponent } from "../../custom-kendo/upload-image-dialog/upload-image-dialog.component";
import { EditorComponent } from "@progress/kendo-angular-editor";
import { acceptedFileTypes, acceptedFileTypesText} from 'app-models';

@Component({
  selector: 'app-other-document',
  templateUrl: './other-document.component.html',
  styleUrls: ['./other-document.component.scss']
})
export class OtherDocumentComponent implements OnInit {

  disabledFields: boolean = false;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyId;
  @ViewChild('f', { static: false }) compDescForm: NgForm;
  description;
  selectedDocType: '';
  // public options: any = FroalaEditorOptions.EditorOptions;
  formChangesSubscription: any;
  dirtyFlag: boolean = false;
  @ViewChild("otherimageupload") public otherimageupload: UploadImageDialogComponent;
  @Output() @ViewChild("otherdockendoeditor") public otherdockendoeditor: EditorComponent;



  test = {};
  attorneyCompanyId;
  company = new Company({
    petitionFeesInfo: [{
      questionCategory: {
        additionalInfo: '',
        answer: 0,
        beneficiaryId: null,
        companyId: null,
        employeeId: null,
        familyId: null,
        id: null,
        questionId: null
      },
      response: null
    }]
  });

  descriptionId;
  disableFields = false;
  uploadedFile: any;
  envPath: any;
  documentTypeCode = 'COMPGENDOC';
  documentTypes = [];
  fileCategory = '';
  useCase = 'company';
  useCaseId = '';
  entityId = parseInt(sessionStorage.getItem('companyId'));
  currentState = '';
  uploadedDocuments = [];
  acceptedTypes = acceptedFileTypes;
  acceptedTypesText = acceptedFileTypesText;
  constructor(protected store: Store<any>,
    private uploadDocumentService: UploadDocumentService,
    private referenceLibraryService: ReferenceLibraryService,
    private confirmationService: ConfirmationService,
    private companyService: CompanyService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog) {
    let modeOfCreation = this.activatedRoute.snapshot.queryParamMap.get('modeOfCreation');
    this.activatedRoute.params
      .subscribe(parameter => {
        if (parameter.hasOwnProperty('id')) {
          this.companyId = parseInt(parameter.id);
          debugger
          console.log('this.companyId', this.companyId);
          if(this.companyId){
            this.getCompanyDescription();
            this.companyService.getCompaniesById(parameter.id).subscribe(data => {
              this.currentState = data.status.code;
              if (data.status.code == 'ACTV' && modeOfCreation == 'INVITED')
                this.disableFields = true;
            });
          }
         
        } else {

        }
      });
  }


  ngOnInit() {
    this.attorneyCompanyId = parseInt(sessionStorage.getItem('companyId'));
    this.useCaseId = this.companyId;
    this.getallData();
  }

  public openotherimageuploaddialog() {
    this.otherimageupload.open();
  }



  getallData() {
    this.getCompanyDescription();
    this.getDocumentTypes();
    this.getUploadedDocuments();
    this.getQuestions();
  }

  getDocumentTypes() {
    this.referenceLibraryService.getReferenceData(this.documentTypeCode)
      .subscribe((response: ReferenceLibrary[]) => {
        this.documentTypes = response;
      });
  }

  getCompanyDescription() {

    this.companyService.getCompanyDescription(this.companyId).subscribe((response) => {
      if (response) {
        this.company.title = '';
        this.description = response['description'];
        this.descriptionId = response['id'];
      }
    });
  }

  getUploadedDocuments() {
    this.uploadDocumentService.genericGetUploadDocument(
      this.useCase, this.companyId, this.documentTypeCode, '', false, null)
      .subscribe(response => {
        if (response.status === 200) {
          //this.toastr.success(response.message);
          this.uploadedDocuments = response['data'];
          //this.files = [];
        }
        else {
          this.uploadedDocuments = [];
        }
      });
  }

  getQuestions() {
    if (this.attorneyCompanyId) {
      this.companyService.getQuestions('QUECTGTYP', this.companyId).subscribe((response: PetitionFeesInfo[]) => {
        this.company.petitionFeesInfo = response.filter(x => x.questionCategory['group'] === 'QUECTGTYP').map((item) => {
          if (item.response) {
            item['isEnabled'] = item.response.answer === 1 ? true : false;
            item.response.answer = item.response.answer === 1 ? true : false;
          }
          else {
            item['isEnabled'] = false;
            item.response = {
              answer: false
            };
          }
          return item;
        });
      });

    }
  }

  ngAfterViewInit() {

    this.formChangesSubscription = this.compDescForm.statusChanges.subscribe(() => {
      if (this.compDescForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
        this.dirtyFlag = true;
      }
      else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.dirtyFlag = false;
      }
    });
  }

  otherDocumentsFormSub() {
    const payload = {
      title: '',
      description: this.description,
      id: this.descriptionId ? this.descriptionId : '',
      companyId: this.companyId
    }
    if (this.disableFields) {
      payload.id = '';
    }

    const payload1 = [];
    this.company.petitionFeesInfo.forEach((item) => {
      payload1.push({
        answer: item.response.answer ? 1 : 0,
        companyId: this.companyId,
        id: item.response && item.response.id ? item.response.id : null,
        questionId: item.id
      });
    });

    this.companyService.saveCompanyDescription(payload).subscribe((response) => {
      if (response['status'] == 200) {
        //this.toastr.success('Company descripton saved succesfully');
        //this.onNext();
        this.companyService.saveCompanyFeesInfo(payload1).subscribe((response) => {
          if (response.status == 200) {
            //this.compDescForm.reset(this.compDescForm.value);
            this.store.dispatch(new MarkCleanFormAction({
              dirty: false
            }));
            this.dirtyFlag = false;
            this.toastr.success('Data Saved succesfully', 'Success');
            if (response.status == 200) {
              this.router.navigate([`/attorney-landing/clients`]);
            }
          }
        });
      }
    });
  }

  toggle(idx) {
    this.company.petitionFeesInfo[idx].response.answer = !this.company.petitionFeesInfo[idx].response.answer;
    this.dirtyFlag = true;
    this.store.dispatch(new MarkDirtyFormAction({
      dirty: true
    }));
  }

  onNext() {

    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.notify.emit(2);
        }
      });

    } else {
      this.notify.emit(2);
    }
  }

  onCancel() {
    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.router.navigate([`/attorney-landing/clients`]);
        }
      });

    } else {
      this.router.navigate([`/attorney-landing/clients`]);
    }

  }

  onPrevious() {
    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.notify.emit(0);
        }
      });

    } else {
      this.notify.emit(0);
    }
  }




  onUpload(event, fileUpload) {
    //this.uploadDocument();

    for (let file of event.files) {
      this.uploadedFile = file;
      this.uploadedFile["fileName"] = file.name;
    }
    let payload = new FormData();
    payload.append("file", this.uploadedFile, this.uploadedFile.fileName);
    this.uploadDocumentService.genericUploadDocument(
      this.useCase, this.companyId, this.documentTypeCode, this.entityId, this.selectedDocType, '', payload, null)
      .subscribe(response => {
        if (response.status === 200) {
          this.toastr.success(response.message, 'Success');
          this.getUploadedDocuments();
          //this.files = [];

        }
      });
    fileUpload.clear();
  }

  openDoc(fileLocation) {
    const docPath = fileLocation.substring(23);
    window.open(`${environment.docs}${docPath}`, "_blank");
  }

  confirmDelete(uploadedFile) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      accept: () => {
        this.deleteFiles(uploadedFile);
      },
      reject: () => {
      }
    });
  }

  deleteFiles(uploadedFile) {
    if (uploadedFile["fileLocation"] != null) {
      this.uploadDocumentService.genericDeleteUploadDocument(
        this.useCase, this.companyId, uploadedFile.fileCategory.group, uploadedFile.fileCategory.code, uploadedFile.id,
        this.entityId, false, null).subscribe((response: any) => {
          if (response) {
            this.toastr.success(response.message, 'Success');
            this.getUploadedDocuments();
            this.uploadedFile = "";
          }
        });
    }
    else {
      this.uploadedFile = "";
    }
    //
  }

  download(doc) {
    this.uploadDocumentService.downloadDocuments(environment.docs + doc.fileLocation.substring(23), doc.fileLocation.substring(23));
  }

  public otherdocumentkendoeditorValueChange(value: string): void {
    this.description = value;
  }

}
